import ProfileService from 'services/ProfileService'
import { BaseResponse, UserDataResponse } from 'services/types'

export const fetchUserData = async (): Promise<BaseResponse<UserDataResponse>> => {
  const result = await ProfileService.getUserData()
  return result
}
